"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/***********************************************
 * Const
 * ********************************************/
var html = document.documentElement;
var body = document.body;

// ハンバーガーボタン
var hamburgerButton = document.getElementById("js-hamburgerButton");

// ページ内リンク
var smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

// スライダー
var sliders = document.querySelectorAll(".p-sec02__slider");

// モーダル
var modalTrigger = document.querySelectorAll(".p-gift__loop__item");
var modalWindows = document.querySelectorAll(".p-gift__modal__window");

/***********************************************
 * Method
 * ********************************************/
Array.from(sliders).map(function (slider, index) {
  var slideLength = slider.querySelectorAll(".swiper-slide").length;
  return new Swiper(".js-shop0".concat(index + 1, "Slider"), {
    loop: slideLength > 1,
    speed: 1000,
    allowTouchMove: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".js-shop0".concat(index + 1, "Slider .swiper-button-next"),
      prevEl: ".js-shop0".concat(index + 1, "Slider .swiper-button-prev")
    }
  });
});
var _iterator = _createForOfIteratorHelper(modalTrigger),
  _step;
try {
  var _loop2 = function _loop2() {
    var modalTrigger = _step.value;
    modalTrigger.addEventListener("click", function (e) {
      console.log("clicked");
      e.preventDefault();
      var modalId = modalTrigger.dataset.targetModal;
      var modal = document.getElementById(modalId);
      modal.parentElement.classList.add("is-active");
      modal.classList.add("is-active");
      document.body.classList.add("is-modalOpen");
    });
  };
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop2();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
var _iterator2 = _createForOfIteratorHelper(modalWindows),
  _step2;
try {
  var _loop3 = function _loop3() {
    var modalWindow = _step2.value;
    var closeButton = modalWindow.querySelector(".p-gift__modal__close");
    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      modalWindow.classList.remove("is-active");
      modalWindow.parentElement.classList.remove("is-active");
      document.body.classList.remove("is-modalOpen");
    });
  };
  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
    _loop3();
  }

  //MVのアニメーションタイムラインの設定
  // function timeline(callback) {
  //   const tl1 = document.querySelector(".js-tl1");
  //   const tl2 = document.querySelector(".js-tl2");
  //   const tl3 = document.querySelector(".js-tl3");
  //   const tl4 = document.querySelector(".js-tl4");
  //   const tl5 = document.querySelector(".js-tl5");

  //   const TL = gsap.timeline();
  //   TL.to(tl1, { duration: 0.6, opacity: 1, delay: 0 }) //.add(() => tl1.classList.add('is-start'))
  //     .to(tl2, { duration: 0.6, opacity: 1, delay: 0.1 })
  //     .to(tl3, { duration: 0.6, opacity: 1, delay: 0.2 })
  //     .to(tl4, { duration: 0.6, opacity: 1, delay: 0.3 })
  //     .to(tl5, { duration: 0.6, opacity: 1, delay: 0.4 })
  //     .call(callback);
  // }

  // ------------------------ ハンバーガーメニュー
} catch (err) {
  _iterator2.e(err);
} finally {
  _iterator2.f();
}
function openHeaderNav() {
  hamburgerButton.addEventListener("click", function (e) {
    // console.log(e)
    var headerNavOpened = body.classList.contains("is-navOpen");
    if (headerNavOpened) {
      hamburgerButton.classList.remove("is-open");
      body.classList.remove("is-navOpen");
      html.style.overflow = "";
      document.querySelector("canvas").style.opacity = 1;
    } else {
      hamburgerButton.classList.add("is-open");
      body.classList.add("is-navOpen");
      html.style.overflow = "hidden";
      document.querySelector("canvas").style.opacity = 0;
    }
  });
}
if (hamburgerButton) {
  openHeaderNav();
}

// ------------------------ ページ内リンク

/**
 * スムーススクロール実行関数
 */

var smoothAnchorScroll = function smoothAnchorScroll() {
  // ページ内リンク
  var smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
  var _loop = function _loop(i) {
    smoothScrollTrigger[i].addEventListener("click", function (e) {
      e.preventDefault();
      var headerNavOpened = body.classList.contains("is-navOpen");
      if (headerNavOpened) {
        hamburgerButton.classList.remove("is-open");
        body.classList.remove("is-navOpen");
        html.style.overflow = "";
      }
      var href = smoothScrollTrigger[i].getAttribute("href");
      var targetElement = document.getElementById(href.replace("#", ""));
      var rect = targetElement.getBoundingClientRect().top;
      var offset = window.pageYOffset;
      //  const gap = smoothOffset ? smoothOffset : 0;
      var target = rect + offset;
      window.scrollTo({
        top: target,
        behavior: "smooth"
      });
    });
  };
  for (var i = 0; i < smoothScrollTrigger.length; i++) {
    _loop(i);
  }
};

//スクロール位置に合わせてナビゲーションのアイコンのON／OFFを調整
// class PagePositionNav {
//   constructor() {
//     this.controller = new ScrollMagic.Controller();
//     this.sections = "[data-page-section]";
//     this.settings = {
//       addClassName: "is-current",
//     };
//   }

//   init(options) {
//     this.setup(options);
//     this.attachEvent(this.controller);
//   }

//   setup(options) {
//     this.settings = Object.assign(
//       {
//         addClassName: this.settings.addClassName,
//       },
//       options || {}
//     );
//   }

//   attachEvent(controller) {
//     let sections = document.querySelectorAll(this.sections);

//     for (let section of sections) {
//       let scene_pagePositionNav = new ScrollMagic.Scene({
//         triggerElement: section,
//         // triggerHook: 0.15,
//         triggerHook: 0.5,
//         duration: section.clientHeight,
//         offset: 0,
//       })
//         // .addIndicators()
//         .addTo(controller);

//       scene_pagePositionNav.on("enter", () => {
//         let targetElement = scene_pagePositionNav.triggerElement();
//         this.removeNavActiveClass();
//         document
//           .querySelector(
//             `[ data-page-nav = ${targetElement.getAttribute(
//               "data-page-section"
//             )}]`
//           )
//           .classList.add(this.settings.addClassName);
//       });

//       scene_pagePositionNav.on("leave", () => {
//         this.removeNavActiveClass();
//       });

//       scene_pagePositionNav.on("update", function (event) {
//         this.duration(section.clientHeight);
//       });
//     }
//   }

//   removeNavActiveClass() {
//     let navElements = document.querySelectorAll("[data-page-nav]");
//     for (let navElement of navElements) {
//       navElement.classList.remove(this.settings.addClassName);
//     }
//   }
// }

// const pagePositionNav = new PagePositionNav();
// pagePositionNav.init();

//scroll magicのコントローラーの定義
var controller = new ScrollMagic.Controller();

//ページトップのフェードイン
(function () {
  var tween = TweenMax.fromTo(".js-fadeIn", 0.5, {
    opacity: 0
  }, {
    opacity: 1
  });
  new ScrollMagic.Scene({
    triggerElement: "#main",
    triggerHook: 0
  }).setTween(tween)
  // .addIndicators()
  .addTo(controller);
})();

//フローティングバナーのフェードイン
// (function () {
//   const targetAreas = document.querySelectorAll(".js-scrollFadeArea");
//   targetAreas.forEach((area) => {
//     new ScrollMagic.Scene({
//       triggerElement: area,
//       triggerHook: "onCenter",
//       duration: area.clientHeight,
//       offset: 0,
//     })
//       .setClassToggle(".js-scrollFade", "is-current")
//       // .addIndicators()
//       .addTo(controller);
//   });
// })();

//バナーの非表示ボタン
// const banners = document.querySelectorAll(".js-banner");
// banners.forEach((banner) => {
//   let closeBtn = banner.querySelector(".js-banner__closeBtn");
//   closeBtn.addEventListener("click", (e) => {
//     banner.remove();
//   });
// });

// p-gift スライダー
var centerSliders = document.querySelectorAll(".swiperCenter");
Array.from(centerSliders).map(function (slider, index) {
  // return new Swiper(`.js-swiperCenter0${index + 1}`, {
  //   slidesPerView: "auto",
  //   centeredSlides: false,
  //   loop: false,
  //   spaceBetween: 20,
  //   threshold:10,
  //   navigation: {
  //     nextEl: `.js-swiperCenter0${index + 1}-next`,
  //     prevEl: `.js-swiperCenter0${index + 1}-prev`
  //   },
  // });
  var splide = new Splide(".js-swiperCenter0".concat(index + 1), {
    mediaQuery: "max",
    breakpoints: {
      768: {
        padding: slider.dataset.perPage ? 0 : {
          right: "25%"
        },
        perPage: slider.dataset.perPage ? slider.dataset.perPage - 1 : 1
      }
    },
    rewind: true,
    rewindSpeed: 0,
    rewindByDrag: true,
    // type: 'loop',
    perPage: slider.dataset.perPage ? slider.dataset.perPage : 2,
    perMove: 1,
    gap: "20px",
    clones: 0,
    arrows: true,
    classes: {
      arrows: "splide__arrows",
      arrow: "splide__arrow p-gift__loop__btn",
      prev: "splide__arrow--prev p-gift__loop__btn-prev",
      next: "splide__arrow--next p-gift__loop__btn-next"
    }
  });
  splide.mount();
  splide.on("mounted", function () {
    slider.querySelectorAll(".splide__slide--clone").forEach(function (slide) {
      slide.remove();
    });
  });
});

// p-gift スライダー
var leftSliders = document.querySelectorAll(".swiperLeft");
Array.from(centerSliders).map(function (slider, index) {
  return new Swiper(".js-swiperLeft0".concat(index + 1), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    slidesPerView: 2
  }, "slidesPerView", "auto"), "loop", true), "threshold", 10), "navigation", {
    nextEl: ".js-swiperLeft0".concat(index + 1, "-next"),
    prevEl: ".js-swiperLeft0".concat(index + 1, "-prev")
  }), "breakpoints", {
    768: {
      slidesPerView: 1
    }
  }));
});

// snow

(function () {
  var COUNT = 170;
  var masthead = document.querySelector(".js-snow");
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  var width = masthead.clientWidth;
  var height = masthead.clientHeight;
  var i = 0;
  var active = false;
  function onResize() {
    width = masthead.clientWidth;
    height = masthead.clientHeight;
    canvas.width = width;
    canvas.height = height;
    ctx.fillStyle = "#fcdfa4";
    var wasActive = active;
    active = width > 200;
    if (!wasActive && active) requestAnimFrame(update);
  }
  var Snowflake = function Snowflake() {
    this.x = 0;
    this.y = 0;
    this.vy = 0;
    this.vx = 0;
    this.r = 0;
    this.reset();
  };
  Snowflake.prototype.reset = function () {
    this.x = Math.random() * width;
    this.y = Math.random() * -height;
    this.vy = 0.3 + Math.random() * 1.0; //速度
    this.vx = 0.25 - Math.random(); //横の揺れ
    this.r = 0.8 + Math.random() * 10; //大きさ
    // this.r = 0.5 + Math.random() * 6; //大きさ
    this.o = 0.3 + Math.random() * 1; //透明度
  };
  canvas.style.position = "fixed";
  canvas.style.left = canvas.style.top = "0";
  canvas.style.zIndex = 3;
  canvas.style.pointerEvents = "none";
  var snowflakes = [],
    snowflake;
  for (i = 0; i < COUNT; i++) {
    snowflake = new Snowflake();
    snowflake.reset();
    snowflakes.push(snowflake);
  }
  function update() {
    ctx.clearRect(0, 0, width, height);
    if (!active) return;
    for (i = 0; i < COUNT; i++) {
      snowflake = snowflakes[i];
      snowflake.y += snowflake.vy;
      snowflake.x += snowflake.vx;
      ctx.globalAlpha = snowflake.o;
      ctx.beginPath();
      ctx.arc(snowflake.x, snowflake.y, snowflake.r, 0, Math.PI * 5, false);
      ctx.closePath();
      ctx.fill();
      if (snowflake.y > height) {
        snowflake.reset();
      }
    }
    requestAnimFrame(update);
  }
  window.requestAnimFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };
  }();
  onResize();
  window.addEventListener("resize", onResize, false);
  masthead.appendChild(canvas);
})();

/****************************************************** */

var getJson = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url) {
    var results;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetch(url);
        case 1:
          results = _context.v;
          if (results.ok) {
            _context.n = 2;
            break;
          }
          return _context.a(2, {
            isSuccess: false,
            message: results.statusText
          });
        case 2:
          return _context.a(2, {
            isSuccess: true,
            data: results.json()
          });
      }
    }, _callee);
  }));
  return function getJson(_x) {
    return _ref.apply(this, arguments);
  };
}();
var setEvents = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(eventsData) {
    var today,
      target,
      ul,
      ulArray,
      p,
      _p,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          today = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : new Date();
          target = document.getElementById("event_banners");
          ul = document.createElement("ul");
          ul.classList.add("p-sec01__banners");
          ulArray = eventsData.map(function (data) {
            var startDate = new Date(data.startDate);
            var endDate = new Date(data.endDate);
            if (today < startDate) return "before";
            if (today > endDate) return "after";
            var li = document.createElement("li");
            var anchor = document.createElement("a");
            var img = document.createElement("img");
            li.setAttribute("id", data.id);
            li.setAttribute("data-page-section", data.dataPageSection);
            anchor.setAttribute("href", data.url);
            anchor.setAttribute("target", "_blank");
            img.setAttribute("src", data.imageUrl);
            img.setAttribute("alt", data.title);
            anchor.appendChild(img);
            li.appendChild(anchor);
            ul.appendChild(li);
            return li;
          });
          if (!ulArray.every(function (v) {
            return v === "before";
          })) {
            _context2.n = 1;
            break;
          }
          p = document.createElement("p");
          p.classList.add("caution");
          p.textContent = "ただいま準備中です。今しばらくお待ちください。";
          target.appendChild(p);
          return _context2.a(2);
        case 1:
          if (!ulArray.every(function (v) {
            return v === "after";
          })) {
            _context2.n = 2;
            break;
          }
          _p = document.createElement("p");
          _p.classList.add("caution");
          _p.innerHTML = "全イベントが終了いたしました。<br>ご来場いただき誠にありがとうございました。";
          target.appendChild(_p);
          return _context2.a(2);
        case 2:
          target.appendChild(ul);
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function setEvents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var setNav = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(eventsData) {
    var today,
      target,
      displayCount,
      ul,
      ulArray,
      p,
      _p2,
      _args3 = arguments;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          today = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : new Date();
          target = document.getElementById("event_nav");
          displayCount = 0;
          ul = document.createElement("ul");
          ul.classList.add("p-aside__nav__list__shops");
          ulArray = eventsData.map(function (data) {
            var startDate = new Date(data.startDate);
            var endDate = new Date(data.endDate);
            if (today < startDate) return "before";
            if (today > endDate) return "after";
            var li = document.createElement("li");
            var anchor = document.createElement("a");
            var spanJa = document.createElement("span");
            li.setAttribute("data-page-nav", data.dataPageSection);
            anchor.setAttribute("href", "#" + data.id);
            spanJa.classList.add("ja");
            spanJa.innerHTML = "".concat(data.title, " \u25B6");
            anchor.appendChild(spanJa);
            li.appendChild(anchor);
            ul.appendChild(li);
            displayCount++;
            return "ok";
          });
          if (!ulArray.every(function (v) {
            return v === "before";
          })) {
            _context3.n = 1;
            break;
          }
          p = document.createElement("p");
          p.classList.add("p-aside__nav__list__caution");
          p.innerHTML = "ただいま準備中です。<br>今しばらくお待ちください。";
          target.appendChild(p);
          return _context3.a(2);
        case 1:
          if (!ulArray.every(function (v) {
            return v === "after";
          })) {
            _context3.n = 2;
            break;
          }
          _p2 = document.createElement("p");
          _p2.classList.add("p-aside__nav__list__caution");
          _p2.innerHTML = "全イベントが終了いたしました。<br>ご来場いただき誠にありがとうございました。";
          target.appendChild(_p2);
          return _context3.a(2);
        case 2:
          target.appendChild(ul);
        case 3:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function setNav(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
document.addEventListener("DOMContentLoaded", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
  return _regenerator().w(function (_context4) {
    while (1) switch (_context4.n) {
      case 0:
        _context4.n = 1;
        return setEventList();
      case 1:
        smoothAnchorScroll();
      case 2:
        return _context4.a(2);
    }
  }, _callee4);
})));
var setEventList = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
    var _getUrlParams, testdate, mode, today, jsonFile, results, events, _t;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          _getUrlParams = getUrlParams(), testdate = _getUrlParams.testdate, mode = _getUrlParams.mode;
          today = testdate && mode === "test" ? new Date(testdate) : new Date(); // const today = new Date("2025-12-08");
          jsonFile = "event_list.json";
          _context5.n = 1;
          return getJson(jsonFile);
        case 1:
          results = _context5.v;
          if (results.isSuccess) {
            _context5.n = 2;
            break;
          }
          return _context5.a(2);
        case 2:
          _context5.n = 3;
          return results.data;
        case 3:
          events = _context5.v;
          _context5.n = 4;
          return Promise.all([setEvents(events, today), setNav(events, today)]);
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t = _context5.v;
          console.error(_t);
        case 6:
          return _context5.a(2);
      }
    }, _callee5, null, [[0, 5]]);
  }));
  return function setEventList() {
    return _ref5.apply(this, arguments);
  };
}();
var getUrlParams = function getUrlParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  try {
    var urlObj = new URL(url);
    var params = new URLSearchParams(urlObj.search);
    var result = {};
    var _iterator3 = _createForOfIteratorHelper(params),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          key = _step3$value[0],
          value = _step3$value[1];
        result[key] = value;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return result;
  } catch (error) {
    console.error("Invalid URL:", error);
    return {};
  }
};